export default "__VITE_ASSET__553245e0__$_?component__"